import {createRouter, createWebHistory} from 'vue-router'
import {wwwScrollTo} from '@/composables/www/useLenis'
import {wwwRoutes} from '@/entrypoints/www/routes'

const basePath: string = import.meta.env.VITE_BASE_WWW_PATH || '/www/'

const router = createRouter({
    history: createWebHistory(basePath),
    routes: wwwRoutes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve) => {
            // Wait for lazy route views to paint before Lenis scrolls.
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (savedPosition) {
                        wwwScrollTo(savedPosition.top, {immediate: true})
                    } else if (to.hash) {
                        wwwScrollTo(to.hash, {offset: -96, immediate: true})
                    } else if (to.path !== from.path) {
                        wwwScrollTo(0, {immediate: true})
                    }
                    resolve(false)
                })
            })
        })
    },
})

export default router
